import { createFileRoute } from '@tanstack/react-router';
import ImportListView from '../bulk-import/imports/list/import-list-view';
export const Route = createFileRoute('/bulk-import/imports/')({ component: ImportListView });
